import React from 'react';

export default class Colorpicker extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            colors: [
                ['#000000', '#434343', '#666666', '#999999', '#B7B7B7', '#CCCCCC', '#D9D9D9', '#EFEFEF', '#F3F3F3', '#FFFFFF'],
                ['#F44336', '#FF9800', '#FFEB3B', '#8BC34A', '#00BCD4', '#03A9F4', '#2196F3', '#3F51B5', '#673AB7', '#9C27B0'],
                ['#FFCDD2', '#FFE0B2', '#FFF9C4', '#DCEDC8', '#B2EBF2', '#B3E5FC', '#BBDEFB', '#C5CAE9', '#D1C4E9', '#E1BEE7'],
                ['#EF9A9A', '#FFCC80', '#FFF59D', '#C5E1A5', '#80DEEA', '#81D4FA', '#90CAF9', '#9FA8DA', '#B39DDB', '#CE93D8'],
                ['#EF5350', '#FFA726', '#FFEE58', '#9CCC65', '#26C6DA', '#29B6F6', '#42A5F5', '#5C6BC0', '#7E57C2', '#AB47BC'],
                ['#D32F2F', '#F57C00', '#FBC02D', '#689F38', '#0097A7', '#0288D1', '#1976D2', '#303F9F', '#512DA8', '#7B1FA2'],
                ['#B71C1C', '#E65100', '#F57F17', '#33691E', '#006064', '#01579B', '#0D47A1', '#1A237E', '#311B92', '#4A148C'],
            ],
        };

        this.getRows = this.getRows.bind(this);
        this.getColors = this.getColors.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    getRows() {
        const { colors } = this.state;

        return colors.map((row, i) => (
            <div className="colorpicker__row" key={`row-${i}`}>
                {this.getColors(row)}
            </div>
        ));
    }

    getColors(row) {
        return row.map((color) => (
            <span
                onClick={this.handleClick}
                className="colorpicker__color"
                data-color={color}
                style={{ background: color }}
                key={`color-${color}`}
            />
        ));
    }

    handleClick(e) {
        const { color } = e.currentTarget.dataset;
        const { onChange, type } = this.props;

        onChange({ [type]: color });
    }

    handleChange(e) {
        const color = e.currentTarget.value;
        const { onChange, type } = this.props;

        e.key === 'Enter' && onChange({ [type]: color });
    }

    render() {
        return (
            <div className="colorpicker__container">
                { this.props.children }
                <div className="colorpicker">
                    <label htmlFor="color-picker-input" className="colorpicker__label">HEX color</label>
                    <input
                        id="color-picker-input"
                        className="colorpicker__input"
                        type="text"
                        placeholder="Пример: #FFFFFF"
                        onKeyDown={this.handleChange}
                    />
                    {this.getRows()}
                </div>
            </div>
        );
    }
}
